import React from "react";
import "./ToggleButton.scss";
import Loader from "../../Loader";

const ToggleButton = (props) => {
  const {
    value = false,
    disabled,
    onChange,
    reverse = false,
    className,
    label,
    isLoading = false,
    ...rest
  } = props;

  const handleClick = () => {
    onChange?.(!value);
  };

  return (
    <div className="d-flex align-items-center button-space">
      {label ? <label className="onoff-label">{label} </label> : null}
      <div
        className={`onoff-switch ${value ? "active" : ""}`}
        style={{
          opacity: disabled ? 0.7 : 1,
          cursor: disabled ? "" : "pointer",
        }}
        onClick={() => {
          if (!disabled && !isLoading) {
            handleClick()
          }
        }
        }
      >
        <span className="text">
          {isLoading ? <Loader className="justify-content-start" /> : value ? "ON" : "OFF"}
        </span>
        <div className="thumb" />
      </div>
    </div>
  );
};

export default ToggleButton;
